import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    tooManySelectedText: ({ actionName, assetCount }: {
        actionName: string;
        assetCount?: number;
    }) => string;
    errorMessageToast: ({ actionName }: {
        actionName: string;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Message shown when the selection exceeds the supported limit for this action. */
            tooManySelectedText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ actionName, assetCount = 100 }: {
                        actionName: string;
                        assetCount?: number;
                    }): string => __intl__.intl().formatMessage({ id: "sharedStrings.tooManySelectedText?c=nuuvecnkvs6z", defaultMessage: "{actionName} can be applied to up to {assetCount} assets at a time." }, { actionName: actionName, assetCount: assetCount }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when we fail to start the remove background generation. */
            errorMessageToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ actionName }: {
                        actionName: string;
                    }): string => __intl__.intl().formatMessage({ id: "sharedStrings.errorMessageToast?c=cq1r47a5o4qj", defaultMessage: "There was an error starting the {actionName} generation." }, { actionName: actionName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
